<template>
  <div id="contact-address" v-if="showFields">

    <!-- List all additional fields defined by the Delivery method -->
    <div v-for="(field, index) in deliveryAdditionalFields" :key="index + field.fieldPath">

      <text-field
        :data="delivery.additionalInfo"
        :name="field.fieldPath"
        :label='field.label'
        kind='input'
        type='text'
        :placeholder="field.label"
        @updated="formUpdated"
      ></text-field>

    </div>

    <check-field :data="delivery" name="quarantine" @updated="formUpdated" />

  </div>
</template>

<script>
import Cart from '@/cart';
import Utils from '@/utils';

import Validator from '@/service/Validator'
import TextField from '@/components/common/TextField'
import CheckField from '@/components/common/CheckField'
import Notification from '@/notification'

export default {
  name: 'contact-plus-info',
  props: ['shopData', 'delivery'],
  components: {
    TextField,
    CheckField
  },
  data () {
    return {
      Validator: Validator,
      deliveryAdditionalFields: [],
      showFields: false
    };
  },
  created() {
    console.log('ContactPlusInfo::created', this.shopData, this.delivery)
    this.getFields()
    if (this.deliveryAdditionalFields.length > 0) {
      if (this.delivery.additionalInfo === undefined) {
        Vue.set(this.delivery, 'additionalInfo', {})
      }
      this.showFields = true
    }
  },
  methods: {
    getFields() {
      this.shopData.shippings.forEach(shipment => {
        let delivCode = shipment.subCode ? shipment.code + '-' + shipment.subCode : shipment.code
        if (delivCode == this.delivery.code) {
          this.deliveryAdditionalFields.splice(0)

          if (shipment.additionalFields) {
          shipment.additionalFields.forEach(af => {
            let fieldLang = af['en'] ? 'en' : Object.keys(af)[0]
            this.deliveryAdditionalFields.push({
              label: af[Cart.lang],
              fieldPath: Utils.plainText(af[fieldLang])
            })
          })
        }
        }
      })
    },
    validate(cb) {
      this.$validator.validateAll()
      .then(res => {
        if(!res) {
            Notification.add('err', 'Prosím, opravte své údaje', 15)
            cb(false)
        }
        cb(true)
      })
    },
    formUpdated() {
      this.$emit('updated', {calculate: false});
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.field-mandatory {
  position: absolute;
  top: 0px;
  right: 10px;
  color: #f33;
  font-size: 27px;
}
.field-mandatory::after {
  content: "*";
}
</style>
